import { gql } from '@/__generated__';

export const signInDocument = gql(/* GraphQL */ `
  mutation SignIn($data: SignInInput!) {
    signIn(data: $data) {
      token
      user {
        id
        email
        role
        ... on User {
          id
        }
      }
    }
  }
`);

export const signOutDocument = gql(/* GraphQL */ `
  mutation SignOut {
    signOut {
      success
    }
  }
`);
